module.exports = __webpack_public_path__ + "../assets/img/bc190c3be60f23cbe34c03f27d222d2e.webp";